import Vue from 'vue'
import Vuex from 'vuex'
import App from './App.vue'
import router from './router'
import store from './store' // your vuex store
import { createProvider } from './vue-apollo'
import './registerServiceWorker'

Vue.use(Vuex)

import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
Vue.use(BootstrapVue)

import VueInstaller from 'vue-pwa-installer'
Vue.use(VueInstaller, {})

import VueLazyLoad from 'vue-lazyload'
Vue.use(VueLazyLoad)

import movable from 'v-movable'
Vue.use(movable)

import './directives/vueformulate'

import visibility from 'vue-visibility-change'
Vue.use(visibility)

import 'vue-context/dist/css/vue-context.css'

import VueQrcode from '@chenfengyuan/vue-qrcode'
Vue.component(VueQrcode.name, VueQrcode)

import VueToast from 'vue-toast-notification'
import 'vue-toast-notification/dist/theme-default.css'
Vue.use(VueToast, {
	position: 'top-right',
})

import omitDeep from 'omit-deep'
Vue.prototype.$omitDeep = omitDeep

import VuejsDialog from 'vuejs-dialog'
import 'vuejs-dialog/dist/vuejs-dialog.min.css'
Vue.use(VuejsDialog, {
	html: true,
	okText: 'Confirmar',
	cancelText: 'Cancelar',
	animation: 'fade',
})

import VueHtml2Canvas from 'vue-html2canvas'
Vue.use(VueHtml2Canvas)

import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'

// require('@/assets/css/font-awesome.css');
require('@/assets/fontastic/styles.css')
require('@/assets/css/animate.css')
require('@/assets/css/forms.css')
require('@/assets/css/cards.css')
require('@/assets/css/custom.css')

import Ripple from 'vue-material-design-ripple'
import 'vue-material-design-ripple/dist/vue-material-design-ripple.css'
Vue.directive('ripple', Ripple)

const moment = require('moment')
require('moment/locale/es')
Vue.use(require('vue-moment'), { moment })

// import panZoom from 'vue-panzoom'
// Vue.use(panZoom);

import VueProgressBar from 'vue-progressbar'
Vue.use(VueProgressBar, {
	color: '#02bcd7',
	failedColor: 'red',
	height: '2px',
})

import VueSignaturePad from 'vue-signature-pad'
Vue.use(VueSignaturePad)

import VueGeolocation from 'vue-browser-geolocation'
Vue.use(VueGeolocation)

import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'
Vue.component('multiselect', Multiselect)

import '../node_modules/vue-ads-pagination/dist/vue-ads-pagination.css'
import VueAdsPagination, { VueAdsPageButton } from 'vue-ads-pagination'
Vue.component('VueAdsPagination', VueAdsPagination)
Vue.component('VueAdsPageButton', VueAdsPageButton)

import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/locale/es'
import 'vue2-datepicker/index.css'
Vue.component('DatePicker', DatePicker)

import VueTextareaAutosize from 'vue-textarea-autosize'
Vue.use(VueTextareaAutosize)

import ToggleButton from 'vue-js-toggle-button'
Vue.use(ToggleButton)

import VueSimpleSuggest from 'vue-simple-suggest'
import 'vue-simple-suggest/dist/styles.css'
Vue.component('vue-simple-suggest', VueSimpleSuggest)

import VueDraggableResizable from 'vue-draggable-resizable'
import 'vue-draggable-resizable/dist/VueDraggableResizable.css'
Vue.component('vue-draggable-resizable', VueDraggableResizable)

import Donut from 'vue-css-donut-chart'
import 'vue-css-donut-chart/dist/vcdonut.css'
Vue.use(Donut)

import VueApexCharts from 'vue-apexcharts'
Vue.component('apexchart', VueApexCharts)

import Pagination from '@/components/layout/Pagination'
Vue.component('Pagination', Pagination)

import Loader from '@/components/layout/Loader'
Vue.component('Loader', Loader)

import Sticky from 'vue-sticky-directive'
Vue.use(Sticky)

import SweetAlertIcons from 'vue-sweetalert-icons'
Vue.use(SweetAlertIcons)

import VueNativeNotification from 'vue-native-notification'
Vue.use(VueNativeNotification, {
	requestOnNotify: true,
})

import VueCurrencyInput from 'vue-currency-input'
Vue.use(VueCurrencyInput)

Vue.config.productionTip = false

new Vue({
	router,
	store,
	apolloProvider: createProvider(),
	render: (h) => h(App),
}).$mount('#app')
